import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _CloseSquareLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsx("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: _jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M18.354 6.354 18.707 6 18 5.293l-.354.353L12 11.293 6.354 5.646 6 5.293 5.293 6l.354.354L11.293 12l-5.646 5.647-.354.353.707.707.354-.353L12 12.707l5.647 5.647.353.353.707-.707-.353-.354L12.707 12z", clipRule: "evenodd" }) }) });
}
const CloseSquareLight = forwardRef(_CloseSquareLight);
export { CloseSquareLight };
